import React, { useState, useEffect } from "react";
import { Admin, Resource } from "react-admin";
import { ListGuesser, EditGuesser } from "react-admin";
import { APIUrl } from "./common/apiClient";
import { MyDataProvider } from "./providers/MyDataProvider";
import VSDataProvider from "./providers/VSDataProvider";

import polyglotI18nProvider from "ra-i18n-polyglot";

import "./App.css";

import authProvider from "./authProvider";
import themeReducer from "./themeReducer";
import { Login, Layout } from "./layout";
import { MainHome } from "./layout/Home";
import { Dashboard } from "./dashboard";
import customRoutes from "./routes";
import { ResetPassword } from './screens/resetpassword/ResetPassword';
import { ForgotPassword } from './screens/forgotpassword/ForgotPassword';
import englishMessages from "./i18n/en";
import employeeattendancereqlist from "./screens/employeeattendancereqlist";
import employeeattendancereqapprove from "./screens/employeeattendancereqapprove";

import roletypes from './screens/roletypes';
import district from "./screens/district";
import state from "./screens/state";
import city from "./screens/city";
import countries from "./screens/country";
import users from './screens/users';
import employee from './screens/employee';
import productgroups from './screens/productgroups';
import products from './screens/products';
import customers from './screens/customers';
import orders from './screens/orders';
import purs from './screens/purs';

import leavetype from './screens/leavetype';
import employeeleavelist from './screens/employeeleavelist'; 
import employeeleaveapprove from './screens/employeeleaveapprove'; 
import employeesalary from './screens/employeesalary'; 
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import configs from './screens/configs';
import lookup from "./screens/lookup";
import zipcode from "./screens/zipcode";
import salespacking from "./screens/salespacking";




const i18nProvider = polyglotI18nProvider((locale) => {
  if (locale === "fr") {
    return import("./i18n/fr").then((messages) => messages.default);
  }

  // Always fallback on english
  return englishMessages;
}, "en");
//console.log(process.env.REACT_APP_SERVER_URL, "==REACT_APP_SERVER_URL==");
const App = () => {
  const [dataProvider, setDataProvider] = useState({});
  const [showSpecialRoute, setShowSpecialRoute] = useState<string | null>(null);

  useEffect(() => {
    let provider = VSDataProvider(APIUrl);
    setDataProvider(provider);
  }, []);

  useEffect(() => {
    // Check for special routes
    const hash = window.location.hash || '';
    console.log('Current hash:', hash); // Debug log
    
    if (hash.includes('#/reset-password')) {
      console.log('Showing reset password'); // Debug log
      setShowSpecialRoute('reset-password');
    } else if (hash.includes('#/forgot-password')) {
      console.log('Showing forgot password'); // Debug log
      setShowSpecialRoute('forgot-password');
    } else {
      console.log('Showing admin'); // Debug log
      setShowSpecialRoute(null);
    }
  }, []);

  if (showSpecialRoute === 'reset-password') {
    return (
      <>
        <ResetPassword />
        <ToastContainer />
      </>
    );
  }
  
  if (showSpecialRoute === 'forgot-password') {
    return (
      <>
        <ForgotPassword />
        <ToastContainer />
      </>
    );
  }
  
  return (
    <>
      <Admin
        title=""
        dataProvider={dataProvider}
        customReducers={{ theme: themeReducer }}
        customRoutes={customRoutes}
        authProvider={authProvider}
        dashboard={Dashboard}
        loginPage={Login}
        layout={Layout}
        i18nProvider={i18nProvider}
      >
        <Resource title="User" name="users" {...users} />
        <Resource title="Employee" name="employees" {...employee} />
        
        {/* <Resource name="lookups" list={ListGuesser} edit={EditGuesser} /> */}
        <Resource title="Role Type" name="role-types" {...roletypes} />
        <Resource name="configdets" list={ListGuesser} edit={EditGuesser} />
        <Resource name="configs" {...configs} />
        <Resource name="leave-types" {...leavetype}/>
        <Resource name="employee-leaves" {...employeeleavelist}/>
        <Resource name="employee-leaves-approve"  {...employeeleaveapprove}/>
        <Resource name="employee-sal"  {...employeesalary}/>
        <Resource name="employee-sal-dets"  list={ListGuesser} edit={EditGuesser}  />
        <Resource title="Country" name="countries" {...countries} />
        <Resource title="City" name="cities" {...city} />
        <Resource title="States" name="states" {...state} />
        <Resource name="districts" {...district} />
        <Resource name="lookups" {...lookup} />
        <Resource name="zipcodes" {...zipcode} />
        <Resource name="employee-docs" list={ListGuesser} edit={EditGuesser} />  
        <Resource name="fit-bit-logs" list={ListGuesser} edit={EditGuesser}  />
        <Resource title="Product Groups" name="product-groups" {...productgroups} />
        <Resource title="Products" name="products" {...products} />
        <Resource title="Customers" name="customers" {...customers} />
        <Resource title="Orders" name="orders" {...orders} />
        <Resource title="Purchase" name="purs" {...purs} />
        <Resource title="Sales Bill" name="sales-bills" {...salespacking} />
        

        
      </Admin>
      <ToastContainer />
    </>
  );
};

export default App;
